import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';

import { EDemandTrapScreen } from '../../containers/DemandActionContainer';
import {
  EStatus,
  fetchCreateHomeownerMessageFromOffer,
  ICreateHomeownerMessageFromOfferResponse200 as IRes200,
  ICreateHomeownerMessageFromOfferResponse400 as IRes400,
} from '../../repositories/demand/v2/create-homeowner-message-from-offer';

interface ISendDemandProps {
  offerId?: number;
  confirmationCode?: string;
  setScreen(screen: EDemandTrapScreen): void;
}

export async function sendDemand({ offerId, confirmationCode, setScreen }: ISendDemandProps) {
  const httpApi = getHttpApi();
  const logger = getLogger();

  const smsCode = typeof confirmationCode === 'string' ? confirmationCode : undefined;

  try {
    const res = await fetchCreateHomeownerMessageFromOffer<IRes200, IRes400>({
      httpApi,
      parameters: {
        offerId,
        confirmationCode: smsCode as string,
        source: 'chats',
      },
    });

    if (res.statusCode === 200) {
      switch (res.response.status) {
        case EStatus.NeedPhoneConfirm:
          setScreen(EDemandTrapScreen.NeedCode);

          return;
        case EStatus.CodeError:
          setScreen(EDemandTrapScreen.SmsCodeError);

          return;
        default:
          setScreen(EDemandTrapScreen.Sent);

          return;
      }
    }

    setScreen(EDemandTrapScreen.GlobalError);
    logger.warning('Bad request /v2/create-homeowner-message-from-offer/', {
      parameters: `offerId=${offerId}&confirmationCode=${smsCode}`,
    });
  } catch (error) {
    setScreen(EDemandTrapScreen.GlobalError);
    logger.error('Failed get /v2/create-homeowner-message-from-offer/', error);
  }
}
